import React from 'react';
import PropTypes from 'prop-types';
import SelectHeads from './SelectHeads';
import SelectStartPlayer from './SelectStartPlayer';
import ReadyButton from './ReadyButton';
import BonusCards from './BonusCards';

/** Setup, in the order it happens: extra cards for a redealt hand, the coin flip, who goes first, then ready. */
const GameStart = ({ userId }) => (
  <>
    <BonusCards userId={userId} />
    <SelectHeads />
    <SelectStartPlayer />
    <ReadyButton userId={userId} />
  </>
);

GameStart.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default GameStart;
